import { Messages } from '../../codegen/Localize';
import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { FlowBaseInfo } from '../models/FlowInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Flows } from '../resources/Flows';
import { IResult } from '../ServerApi/types/IResponse';
import { ActionHelpers } from './ActionHelpers';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { actionErrorTranslation, actionSuccessTranslation } from './ContentActionNotification';
import { FlowErrors } from './FlowErrors';

export class RunFlowAction {

  public static $inject = [
    '$translate',
    'ConfirmActionDialog',
    'FlowErrors',
    'Flows'
  ];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ConfirmActionDialog: ConfirmActionDialog,
    private FlowErrors: FlowErrors,
    private Flows: Flows,
  ) { }

  public showRunFlowDialog(
    flows: Set<FlowBaseInfo>,
    actionContext: IActionContext,
    isRunAllIncremental: boolean = null): ng.IPromise<any> {

    let dialogBody: string;
    const dialogScope = actionContext.scope.$new();

    if (flows.size() === 1) {
      const flow = flows.first();
      dialogBody = this.$translate.instant('runFlowsSinglePrompt', {
        FLOW_NAME: L10n.elideIfLong(flow.name)
      });
    } else {
      dialogBody = this.$translate.instant('runFlowsMultiplePrompt', {
        ITEM_COUNT: flows.size()
      }, L10n.Interpolations.Count);
    }

    const dialogInstance = this.ConfirmActionDialog.open({
      scope: actionContext.scope.$new(),
      title: this.$translate.instant('runNow'),
      bodyText: dialogBody,
      actionName: this.$translate.instant('runNowConfirmButton', {
        ITEM_COUNT: flows.size()
      }, L10n.Interpolations.Count),
      action: () => this.Flows.runFlow(flows.keys(), isRunAllIncremental).then((result: IResult) => {
        ActionHelpers.notifyStandardError(
          flows,
          result,
          {
            success: actionSuccessTranslation(Messages.runFlowsSuccess),
            error: actionErrorTranslation(Messages.runFlowsError),
          },
          (errorItem: IErrorItem<FlowBaseInfo>) => this.FlowErrors.errorDetailsFor(errorItem)
        );
      })
    });

    dialogInstance.result.finally(() => dialogScope.$destroy());

    return dialogInstance.result;
  }
}

Module.instance().service('RunFlowAction', RunFlowAction);
